export const TERMS_AND_PRIVACY_COPY = {
  copyright: 'Copyright © 2023 Polco',
  terms: 'Terms',
  termsAriaLabel: 'Terms of use page',
  privacy: 'Privacy',
  privacyAriaLabel: 'Privacy policy page',
};
